import axios from "axios";
//import store from "../store"

import { harisApiDomain, harisChannelKey } from "../utils/Constants";

const http = new axios.create({
  baseURL: harisApiDomain,
});

const httpMethod = {
  get(url, options = {}) {
    let vuex = JSON.parse(localStorage.getItem("pro-halalize"));
    let accessToken = vuex.Auth.accessToken;
    let header = {
      authorization: `Bearer ${accessToken}`,
      "channel-key": "" + harisChannelKey,
    };

    return http
      .get(url, {
        ...options,
        headers: {
          ...header,
          ...options.headers,
        },
      })
      .then((res) => res.data)
      .then((data) => {
        if (!data.status == "ok") {
          return Promise.reject(data.error);
        }
        return data;
      });
  },
  post(url, data = null, options = {}) {
    let vuex = JSON.parse(localStorage.getItem("pro-halalize"));
    let accessToken = vuex.Auth.accessToken;
    let header = {
      authorization: `Bearer ${accessToken}`,
      "channel-key": harisChannelKey,
    };

    return http
      .post(url, data, {
        ...options,
        headers: {
          ...header,
          ...options.headers,
        },
      })
      .then((res) => res.data)
      .then((data) => {
        if (!data.status == "ok") {
          return data.error;
        }
        return data;
      });
  },
  postWithoutAuth(url, data = null, options = {}) {
    let header = {
      "channel-key": harisChannelKey,
    };

    return http
      .post(url, data, {
        ...options,
        headers: {
          ...header,
          ...options.headers,
        },
      })
      .then((res) => res.data)
      .then((data) => {
        if (!data.status == "ok") {
          return data.error;
        }
        return data;
      });
  },
  create(url, data = null, options = {}) {
    let vuex = JSON.parse(localStorage.getItem("pro-halalize"));
    let accessToken = vuex.Auth.accessToken;
    let header = {
      authorization: `Bearer ${accessToken}`,
      "channel-key": harisChannelKey,
    };

    return http
      .post(url, data, {
        ...options,
        headers: {
          ...header,
          ...options.headers,
        },
      })
      .then((res) => res.data)
      .then((data) => {
        if (!data.status == "ok") {
          return Promise.reject(data.error);
        }
        return data;
      });
  },
  put(url, data = null, options = {}) {
    let vuex = JSON.parse(localStorage.getItem("pro-halalize"));
    let accessToken = vuex.Auth.accessToken;
    let header = {
      authorization: `Bearer ${accessToken}`,
      "channel-key": harisChannelKey,
    };

    return http
      .put(url, data, {
        ...options,
        headers: {
          ...header,
          ...options.headers,
        },
      })
      .then((res) => res.data)
      .then((data) => {
        if (!data.status == "ok") {
          return Promise.reject(data.error);
        }
        return data;
      });
  },
  delete(url, data = null, options = {}) {
    let vuex = JSON.parse(localStorage.getItem("pro-halalize"));
    let accessToken = vuex.Auth.accessToken;
    let header = {
      authorization: `Bearer ${accessToken}`,
      "channel-key": harisChannelKey,
    };
    return http
      .delete(url, data, {
        ...options,
        headers: {
          ...header,
          ...options.headers,
        },
      })
      .then((res) => res.data)
      .then((data) => {
        if (!data.status == "ok") {
          return Promise.reject(data.error);
        }
        return data;
      });
  },
};

export default httpMethod;
